// extracted by mini-css-extract-plugin
export default {"info":"ProductInfo_info__SP-4i"};